import component from './component.vue';

export default [
  {
    path: 'tour',
    props: true,
    component,
    children: [
      {
        path: '/',
        component: () => import('./List/List.vue'),
        props: true,
      },
      {
        path: 'add',
        component: () => import('./Add.vue'),
        props: true,
      },
      {
        path: ':id',
        component: () => import('./Item.vue'),
        props: true,
      },
    ],
  },
  {
    path: 'statistic',
    component: () => import('../Statistic/component.vue'),
    props: true,
  },
];
